import { ROWNUM_WIDTH_KEY } from '../dbGridModel';

/**
 * Column widths of the DB grid, measured from the rendered header cells.
 *
 * Until widths are pinned the table lays itself out from the rows currently
 * drawn — and the virtualizer swaps those rows as you scroll, so every column
 * jiggled left and right (owner, 30.09.2026: "on scroll down the columns are
 * resizing"). The grid now pins them once the first rows have painted, with
 * the same measurement the first manual resize always used.
 *
 * The header draws only VISIBLE columns, so the i-th <th> is the i-th visible
 * column — not result.columns[i - 1] (a hidden column in between used to hand
 * every column right of it its neighbour's width). The row-number column is
 * not draggable but still needs a pinned width.
 *
 * Bounds: a column is never narrower than its header needs (MIN) and one huge
 * JSON / text cell cannot make it enormous (MAX) — cells ellipsize.
 */
export const COLUMN_MIN_PX = 60;
export const COLUMN_MAX_PX = 480;

export function measureColumnWidths(table, visibleColumns) {
  const widths = {};
  table.querySelectorAll('thead th').forEach((cell, i) => {
    const key = i === 0 ? ROWNUM_WIDTH_KEY : visibleColumns[i - 1];
    if (key === undefined) return;
    const w = cell.offsetWidth;
    widths[key] = i === 0 ? w : Math.min(COLUMN_MAX_PX, Math.max(COLUMN_MIN_PX, w));
  });
  return widths;
}
